import { render } from "./ClothesSize.vue?vue&type=template&id=15c7dac6"
import script from "./ClothesSize.vue?vue&type=script&lang=js"
export * from "./ClothesSize.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__